import { useState, useEffect } from "react";
import axios from "axios";
import apiUrls from "../config/api-urls";

export function useCandidateApplicationStatus(token, loggedInUserId, pathname) {
  const [applications, setApplications] = useState(null);

  useEffect(() => {
    const fetchApplicationStatus = async () => {
      try {
        const response = await axios.get(apiUrls.appstatus.status, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const apps = response.data?.applications || [];
        const userApps = apps.filter(
          (app) => app?.userId?._id === loggedInUserId,
        );

        const latestApp = [...userApps].sort(
          (a, b) => new Date(b.appliedDate) - new Date(a.appliedDate),
        )[0];

        if (latestApp) {
          setApplications(latestApp);
          try {
            if (latestApp._id)
              localStorage.setItem("jobApplicationId", latestApp._id);
          } catch {
            // ignore storage errors
          }
        }
      } catch (error) {
        console.error("Failed to fetch application status", error);
      }
    };

    if (token && loggedInUserId) fetchApplicationStatus();
  }, [token, loggedInUserId, pathname]);

  return applications;
}
